export const CONTACT_CATEGORY_CHOICES = {
    CONTACT_CATEGORY_SERVICE: 'service',
    CONTACT_CATEGORY_TECHNICAL: 'technical',
    CONTACT_CATEGORY_BILLING: 'billing',
    CONTACT_CATEGORY_OTHER: 'other',
};
export type ContactCategoryTypes = (typeof CONTACT_CATEGORY_CHOICES)[keyof typeof CONTACT_CATEGORY_CHOICES];

export const CONTACT_CATEGORY_LABEL = {
    [CONTACT_CATEGORY_CHOICES.CONTACT_CATEGORY_SERVICE]: 'サービス内容に関する問い合わせ',
    [CONTACT_CATEGORY_CHOICES.CONTACT_CATEGORY_TECHNICAL]: '機能要望・不具合報告',
    [CONTACT_CATEGORY_CHOICES.CONTACT_CATEGORY_BILLING]: '料金に関する問い合わせ',
    [CONTACT_CATEGORY_CHOICES.CONTACT_CATEGORY_OTHER]: 'その他',
} as const;
